export const
  menuBtn = document.getElementById("mobile-menu-btn"),
  mainNav = document.getElementById("main-nav"),
  navbarMenu = document.querySelector('.navbar-menu'),
  overlayMobile = document.querySelector(".overlay-mobile"),
  overlayDesktop = document.querySelector(".overlay-desktop"),
  hasSubs = document.querySelectorAll(".has-sub"),
  menuToggles = document.querySelectorAll('.menu-toggle'),
  subMenus = document.querySelectorAll(".sub-menu"),
  mq = window.matchMedia("screen and (min-width: 1024px)");
